import { BaseDto } from './base.dto';
import { CustomerDto } from './customer.dto';
import { PaymentMethodDto } from './paymentMethod.dto';

export class CustomerPaymentTypeDto extends BaseDto {
  customer: CustomerDto;
  paymentMethod: PaymentMethodDto;
  paymentMethodId: number;
  token: string;
  data: PaymentSolutionDetails;
  stripeConnectAccountId?: string;
}

export interface PaymentSolutionDetails {
  expiryDate?: string;
  authCode?: string;
  maskedPan?: string;
  nameOnCard?: string;
  cardType?: string;
  formUrl?: string
}
